<app-content-header [headline]="'contact_add_header' | i18next"></app-content-header>
<div class="card card-nb">
  <div class="card-body">
    <div class="row">
      <div [ngClass]="{ 'col-12 col-md-6': showPermissionText, 'col-12': !showPermissionText }">
        @if (!isPartnerInvite) {
          <app-user-profile-form
            (formSubmit)="onCreateSubmit($event)"
            submitButtonLabel="contact_invite_btn"
          ></app-user-profile-form>
        }
        @if (isPartnerInvite) {
          <app-contact-form
            [showMail]="!is20CSP"
            [showInvite]="!is20CSP"
            (formSubmit)="onInviteSubmit($event)"
            submitButtonLabel="app_add"
          ></app-contact-form>
        }
      </div>
      @if (showPermissionText) {
        <div [ngClass]="{ 'col-12 col-md-6': showPermissionText }">
          <h5>{{'contact_mypascom_account_description_header' |  i18next}}</h5>
          <div><i class="fa fa-user-tie red"></i><span class="ml-1">{{'contact_mypascom_account_admin_description' | i18next }}</span>
        </div>
        <div><i class="fa fa-user-circle red"></i><span class="ml-1">{{'contact_mypascom_account_enabled_description' | i18next }}</span>
      </div>
      <div><i class="fa fa-times-circle red"></i><span class="ml-1">{{'contact_mypascom_account_disabled_description' | i18next }}</span>
    </div>
    <div><span class="red">{{'contact_mypascom_account_disabled_note' | i18next }}</span>
  </div>
</div>
}
</div>
</div>
</div>
